import React from "react";
import { FormAddPortefeuille, CustomDialog } from "..";
import { Actif, Portefeuille, User } from "../../interfaces";

interface ModalAddPortefeuilleProps {
  modalIsOpenPortefeuille: boolean;
  closeModalPortefeuille: () => void;
  users: User[];
  actifs: Actif[];
}
const ModalAddPortefeuille = ({
  modalIsOpenPortefeuille,
  closeModalPortefeuille,
  users,
  actifs,
}: ModalAddPortefeuilleProps) => {
  return (
    <CustomDialog
      visible={modalIsOpenPortefeuille}
      closeModalDialog={() => {
        closeModalPortefeuille();
      }}
      header="Ajouter un  portefeuille"
    >
      <div className="w-full h-full">
        <div className="p-6 space-y-6">
          <FormAddPortefeuille
            actifs={actifs}
            users={users}
            closeModalPortefeuille={closeModalPortefeuille}
          />
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalAddPortefeuille;
